// extracted by mini-css-extract-plugin
export default {"community":"community___eNdIC","search":"search___XcDyD","title":"title___PP49x","list":"list___cx9mV","btn":"btn___Hm7SW","cancel":"cancel___bOC3Q","confirm":"confirm___L0EEy"};